<template>
    <div v-if="shouldShow" id="onboarding-layout" >
        <template v-if="onboardingSuccess">
            <b-row class="vh-100" align-v="center">
                <b-col cols="12" md="8" offset-md="2" align-self="center" style="text-align:center">
                    <h3><b-icon icon="check" style="color:green;font-size:50px"></b-icon> You have completed onboarding!</h3>
                    <b-button variant="success" @click="proceed">Continue</b-button>
                </b-col>
            </b-row>
        </template>

        <template v-else>
            <b-col class="mb-4" sm="12" align-v="center">
            <span @click="pauseOnboarding(id, 'integration')"><h1 style="cursor:pointer; right:0"> X </h1></span>
            </b-col>
            <b-row class="vh-100" align-v="center">
                <b-col cols="12" md="8" offset-md="2" align-self="center">
                    <slot></slot>
                </b-col>
            </b-row>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String
        },

        onboardingSuccess: {
            type: Boolean,
            default: false
        },
    },

    data: function() {
        return {
            hide: false
        }
    },

    computed: {
        shouldShow() {
            const integration = this.$store.getters.getIntegrationByID(this.id)
            if (integration.dependencies.length == 1 && integration.dependencies[0] == "platform") return false

            if (this.isIntegrationOnboardingPaused(this.id)) return false
            if (this.hide) return false

            return this.shouldOnboard
        },

        shouldOnboard() {
            const integration = this.$store.getters.getIntegrationByID(this.id)

            return !integration.onboarded
        }
    },

    methods: {
        pauseIntegrationOnboarding(id) {
            this.$store.dispatch('pauseOnboarding', id, "integration")
        },

        isIntegrationOnboardingPaused(id) {
            return this.$store.getters.getPausedOnboardings.find(p => {
                return p.id == id && p.project_uuid == this.$store.getters.getCurrentProject.uuid && p.type == "integration"
            })
        },

        proceed() {
            this.hide = true
            this.$store.dispatch('unpauseOnboarding', this.id, "integration")
            this.$store.commit('INTEGRATION_ONBOARDED', this.id)
        }
    }
}
</script>